(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gxauto-automation"]) return;
  try {
    

function gxautoInit(scope) {
 const root=scope.querySelector('#gxauto-root');
 if(!root||root.dataset.gxautoReady)return;
 root.dataset.gxautoReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxauto-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxauto-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxautoInit(document));
else gxautoInit(document);
document.addEventListener('shopify:section:load',event=>gxautoInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxcip-cleaning"]) return;
  try {
    

function gxcipInit(scope) {
 const root=scope.querySelector('#gxcip-root');
 if(!root||root.dataset.gxcipReady)return;
 root.dataset.gxcipReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxcip-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxcip-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxcipInit(document));
else gxcipInit(document);
document.addEventListener('shopify:section:load',event=>gxcipInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxcu-critical-utilities"]) return;
  try {
    

function gxcuInit(scope) {
 const root=scope.querySelector('#gxcu-root');
 if(!root||root.dataset.gxcuReady)return;
 root.dataset.gxcuReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxcu-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxcu-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxcuInit(document));
else gxcuInit(document);
document.addEventListener('shopify:section:load',event=>gxcuInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxhp-containment"]) return;
  try {
    

function gxhpInit(scope) {
 const root=scope.querySelector('#gxhp-root');
 if(!root||root.dataset.gxhpReady)return;
 root.dataset.gxhpReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxhp-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxhp-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxhpInit(document));
else gxhpInit(document);
document.addEventListener('shopify:section:load',event=>gxhpInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxlyo-lyophilization"]) return;
  try {
    

function gxlyoInit(scope) {
 const root=scope.querySelector('#gxlyo-root');
 if(!root||root.dataset.gxlyoReady)return;
 root.dataset.gxlyoReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxlyo-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxlyo-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxlyoInit(document));
else gxlyoInit(document);
document.addEventListener('shopify:section:load',event=>gxlyoInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxp-home-guides"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gxh-guide-carousel')) {
 class GxhGuideCarousel extends HTMLElement {
  connectedCallback() {
   queueMicrotask(() => {
    if (!this.isConnected || this.abort) return;
    this.track = this.querySelector('.gxh-products');
    this.cards = Array.from(this.querySelectorAll('.gxh-product'));
    this.controls = this.querySelector('.gxh-carousel-controls');
    this.previous = this.querySelector('.gxh-carousel-prev');
    this.next = this.querySelector('.gxh-carousel-next');
    this.counter = this.querySelector('.gxh-carousel-counter');
    if (!this.track || !this.cards.length) return;
    this.abort = new AbortController();
    const signal = this.abort.signal;
    this.previous.addEventListener('click', () => this.move(-this.visible), { signal });
    this.next.addEventListener('click', () => this.move(this.visible), { signal });
    this.track.addEventListener('keydown', event => {
     if (event.target !== this.track) return;
     if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      this.move(event.key === 'ArrowRight' ? 1 : -1);
     } else if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.behavior() });
     }
    }, { signal });
    this.track.addEventListener('scroll', () => {
     cancelAnimationFrame(this.frame);
     this.frame = requestAnimationFrame(() => this.update());
    }, { signal, passive: true });
    this.addEventListener('shopify:block:select', event => {
     const card = event.target.closest('.gxh-product');
     if (card) this.track.scrollTo({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft - 3, behavior: 'auto' });
    }, { signal });
    this.resize = new ResizeObserver(() => this.update());
    this.resize.observe(this.track);
    this.update();
   });
  }
  behavior() {
   return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }
  move(count) {
   this.track.scrollTo({ left: Math.max(0, Math.min(this.track.scrollWidth - this.track.clientWidth, this.track.scrollLeft + this.step * count)), behavior: this.behavior() });
  }
  update() {
   const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
   this.step = this.cards[0].getBoundingClientRect().width + gap;
   this.visible = Math.max(1, Math.round((this.track.clientWidth + gap) / this.step));
   const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
   const first = Math.min(this.cards.length, Math.round(this.track.scrollLeft / this.step) + 1);
   const last = Math.min(this.cards.length, first + this.visible - 1);
   this.previous.disabled = this.track.scrollLeft <= 2;
   this.next.disabled = this.track.scrollLeft >= max - 2;
   this.controls.hidden = max <= 2;
   const template = first === last ? this.dataset.singleCounterTemplate : this.dataset.counterTemplate;
   const text = template.replace('__FIRST__', first).replace('__LAST__', last).replace('__TOTAL__', this.cards.length);
   if (this.counter.textContent !== text) this.counter.textContent = text;
  }
  disconnectedCallback() {
   this.abort?.abort();
   this.abort = null;
   this.resize?.disconnect();
   cancelAnimationFrame(this.frame);
  }
 }
 customElements.define('gxh-guide-carousel', GxhGuideCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxp-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gxp-review-wall')) {
  customElements.define('gxp-review-wall', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.expanded = false;
      this.hovered = false;
      this.focused = false;
      this.inView = false;
      this.speed = Number(this.dataset.speed) || 20;
      this.rails = [...this.querySelectorAll('[data-review-rail]')].map(el => {
        const group = el.querySelector('.gxp-reviews__group');
        const clone = group.cloneNode(true);
        clone.dataset.reviewClone = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.removeAttribute('role');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(n => n.removeAttribute('data-shopify-editor-block'));
        el.querySelector('.gxp-reviews__track').append(clone);
        return {el, group, clone, size:0, direction:Number(el.dataset.direction) || 1, position:0};
      });
      this.classList.add('is-enhanced');
      this.querySelector('.gxp-reviews__controls').hidden = false;
      this.querySelector('[data-review-all]').hidden = false;
      this.measure();
      this.resize = new ResizeObserver(() => this.measure());
      this.rails.forEach(r => {this.resize.observe(r.group);this.resize.observe(r.el);});
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, {threshold:0.05});
      this.observer.observe(this);
      this.querySelector('[data-review-prev]').addEventListener('click', () => this.step(-1), {signal});
      this.querySelector('[data-review-next]').addEventListener('click', () => this.step(1), {signal});
      this.querySelector('[data-review-all]').addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.classList.toggle('is-expanded', this.expanded);
        const button = this.querySelector('[data-review-all]');
        button.setAttribute('aria-expanded', String(this.expanded));
        button.textContent = this.expanded ? this.dataset.showLess : this.dataset.showAll;
        this.measure();
        this.schedule();
      }, {signal});
      const lanes = this.querySelector('.gxp-reviews__lanes');
      lanes.addEventListener('pointerenter', e => {if(e.pointerType === 'mouse'){this.hovered=true;this.schedule();}}, {signal});
      lanes.addEventListener('pointerleave', () => {this.hovered=false;this.schedule();}, {signal});
      lanes.addEventListener('pointerdown', e => {
        this.paused=true;this.schedule();
        const rail=e.target.closest('[data-review-rail]');
        if(e.pointerType==='mouse'&&e.button===0&&rail&&!this.expanded&&!e.target.closest('a,button')){
          this.drag={rail,id:e.pointerId,x:e.clientX,left:rail.scrollLeft};
          rail.setPointerCapture(e.pointerId);
          rail.classList.add('is-dragging');
          e.preventDefault();
        }
      }, {signal});
      lanes.addEventListener('pointermove', e => {if(this.drag?.id===e.pointerId)this.drag.rail.scrollLeft=this.drag.left+this.drag.x-e.clientX;}, {signal});
      const endDrag=()=>{if(this.drag){this.drag.rail.classList.remove('is-dragging');this.drag=null;}};
      lanes.addEventListener('pointerup',endDrag,{signal});
      lanes.addEventListener('pointercancel',endDrag,{signal});
      lanes.addEventListener('lostpointercapture',endDrag,{signal});
      lanes.addEventListener('wheel', e => {if(Math.abs(e.deltaX)>1){this.paused=true;this.schedule();}}, {signal,passive:true});
      lanes.addEventListener('keydown', e => {if(['ArrowLeft','ArrowRight','Home','End','PageDown','PageUp'].includes(e.key)){this.paused=true;this.schedule();}}, {signal});
      this.addEventListener('focusin', e => {if(e.target.closest('[data-review-rail]')){this.focused=true;this.schedule();}}, {signal});
      this.addEventListener('focusout', e => {if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule();}}, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', () => {if(this.motion.matches)this.paused=true;this.schedule();}, {signal});
      document.addEventListener('shopify:block:select', e => {
        if(!this.contains(e.target))return;
        this.paused=true;
        this.schedule();
        e.target.scrollIntoView({block:'nearest',inline:'center',behavior:'instant'});
      }, {signal});
      this.bindLinks();
      document.addEventListener('DOMContentLoaded',()=>this.bindLinks(),{signal});
      document.addEventListener('shopify:section:load',()=>this.bindLinks(),{signal});
      document.addEventListener('click', e=>{
        const link=e.target.closest('[data-gxp-reviews-link]');
        if(link?.hash==='#'+this.querySelector('h2').id){this.paused=true;this.schedule();}
      },{signal});
    }
    measure() {
      if(this.expanded)return;
      this.rails.forEach(r => {
        const old=r.size;
        r.size=r.group.getBoundingClientRect().width;
        r.clone.hidden=r.size<=r.el.clientWidth;
        if(r.clone.hidden){r.position=0;r.el.scrollLeft=0;return;}
        if(!old){
          const stride=r.group.firstElementChild.getBoundingClientRect().width+(parseFloat(getComputedStyle(r.group).columnGap)||20);
          r.position=!this.paused&&r.direction<0?Math.round(r.size*.48/stride)*stride:0;
          r.el.scrollLeft=r.position;
        }
        else if(r.size!==old){r.position=(r.position/old)*r.size;r.el.scrollLeft=r.position;}
      });
    }
    bindLinks() {
      document.querySelectorAll('[data-gxp-reviews-link]').forEach(link=>{
        link.href='#'+this.querySelector('h2').id;
        link.hidden=false;
      });
    }
    step(direction) {
      this.paused=true;
      this.schedule();
      this.rails.forEach(r => {
        if(r.size<=r.el.clientWidth)return;
        const card=r.group.firstElementChild;
        const gap=parseFloat(getComputedStyle(r.group).columnGap)||20;
        const stride=card.getBoundingClientRect().width+gap;
        const index=direction>0?Math.floor((r.el.scrollLeft+1)/stride)+1:Math.ceil((r.el.scrollLeft-1)/stride)-1;
        r.position=((index*stride)%r.size+r.size)%r.size;
        r.el.scrollTo({left:r.position,behavior:'instant'});
      });
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.last=0;
      if(this.paused||this.expanded||this.hovered||this.focused||!this.inView||document.hidden)return;
      this.rails.forEach(r => r.position=r.el.scrollLeft);
      this.frame=requestAnimationFrame(t=>this.tick(t));
    }
    tick(time) {
      if(this.paused||this.expanded||this.hovered||this.focused||!this.inView||document.hidden)return;
      const dt=this.last?Math.min(time-this.last,64):0;
      this.last=time;
      this.rails.forEach(r => {
        if(r.size<=r.el.clientWidth)return;
        r.position=((r.position+dt*this.speed*r.direction/1000)%r.size+r.size)%r.size;
        r.el.scrollLeft=r.position;
      });
      this.frame=requestAnimationFrame(t=>this.tick(t));
    }
    disconnectedCallback() {
      document.querySelectorAll('[data-gxp-reviews-link]').forEach(link=>{if(link.hash==='#'+this.querySelector('h2').id)link.hidden=true;});
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      this.querySelectorAll('[data-review-clone]').forEach(n=>n.remove());
      this.ready=false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxpa-thematic"]) return;
  try {
    

function gxpaInit(scope) {
 const root=scope.querySelector('#gxpa-root');
 if(!root||root.dataset.gxpaReady)return;
 root.dataset.gxpaReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxpa-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxpa-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxpaInit(document));
else gxpaInit(document);
document.addEventListener('shopify:section:load',event=>gxpaInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxpc-cold-chain"]) return;
  try {
    

function gxpcInit(scope) {
 const root=scope.querySelector('#gxpc-root');
 if(!root||root.dataset.gxpcReady)return;
 root.dataset.gxpcReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxpc-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxpc-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxpcInit(document));
else gxpcInit(document);
document.addEventListener('shopify:section:load',event=>gxpcInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxster-sterilization"]) return;
  try {
    

function gxsterInit(scope) {
 const root=scope.querySelector('#gxster-root');
 if(!root||root.dataset.gxsterReady)return;
 root.dataset.gxsterReady='true';
 const tabs=Array.from(root.querySelectorAll('[data-gxster-tab]'));
 const panels=Array.from(root.querySelectorAll('[data-gxster-panel]'));
 function activate(index,focus) {
  tabs.forEach((tab,i)=>{
   const active=i===index;
   tab.setAttribute('aria-selected',String(active));
   tab.tabIndex=active?0:-1;
   tab.toggleAttribute('data-active',active);
   panels[i].hidden=!active;
  });
  if(focus)tabs[index].focus();
 }
 tabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>activate(index,false));
  tab.addEventListener('keydown',event=>{
   let next=index;
   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;
   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();activate(next,true);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxsterInit(document));
else gxsterInit(document);
document.addEventListener('shopify:section:load',event=>gxsterInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gxsu-single-use"]) return;
  try {
    



function gxsuInit(scope) {

 const root=scope.querySelector('#gxsu-root');

 if(!root||root.dataset.gxsuReady)return;

 root.dataset.gxsuReady='true';

 const tabs=Array.from(root.querySelectorAll('[data-gxsu-tab]'));

 const panels=Array.from(root.querySelectorAll('[data-gxsu-panel]'));

 function activate(index,focus) {

  tabs.forEach((tab,i)=>{

   const active=i===index;

   tab.setAttribute('aria-selected',String(active));

   tab.tabIndex=active?0:-1;

   tab.toggleAttribute('data-active',active);

   panels[i].hidden=!active;

  });

  if(focus)tabs[index].focus();

 }

 tabs.forEach((tab,index)=>{

  tab.addEventListener('click',()=>activate(index,false));

  tab.addEventListener('keydown',event=>{

   let next=index;

   if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;

   else if(event.key==='ArrowUp'||event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;

   else if(event.key==='Home')next=0;

   else if(event.key==='End')next=tabs.length-1;

   else return;

   event.preventDefault();activate(next,true);

  });

 });

}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>gxsuInit(document));

else gxsuInit(document);

document.addEventListener('shopify:section:load',event=>gxsuInit(event.target));




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
